module.exports = {
    CLOSE: 0,
    OPEN: 1,
    SEND_EMAIL: 2,
    PROCESSING_EMAIL: 3,
    SENT_EMAIL: 4,
    SENT_EMAIL_WITH_SIZE_WARNING: 6,
    ERROR_EMAIL: 5,
    // Reusing few constants and adding an appropriate name for confirm button constant for incompatible widgets
    REMOVE_WIDGETS: 2,
    OPEN_NOTIFICATION: 3
};



// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/Constants.js